import { useTranslation } from 'react-i18next';

import { ParkingSessionsListPanel } from '@/pages/parking-sessions/parking-sessions-list-panel';

interface VehicleParkingSessionsProps {
	vehicleId: string;
	isActive?: boolean;
}

export const VehicleParkingSessions = ({
	vehicleId,
	isActive = true
}: VehicleParkingSessionsProps) => {
	const { t } = useTranslation('vehicles');

	return (
		<ParkingSessionsListPanel
			vehicleId={vehicleId}
			isActive={isActive}
			emptyMessage={t('parkingSessions.empty')}
		/>
	);
};
